
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/industries/public-sector",
      function () {
        return require("private-next-pages/solutions/industries/public-sector.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/industries/public-sector"])
      });
    }
  